import { render, staticRenderFns } from "./WrappedBath.vue?vue&type=template&id=adfcc698&scoped=true&"
import script from "./WrappedBath.vue?vue&type=script&lang=js&"
export * from "./WrappedBath.vue?vue&type=script&lang=js&"
import style0 from "./WrappedBath.vue?vue&type=style&index=0&id=adfcc698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfcc698",
  null
  
)

export default component.exports